/**
 * Created by Kristy on 2/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patients', {
                parent: 'app',
                url: '/patients',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.patients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/patients/patients.html',
                        controller: 'PatientsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('patientView', {
                abstract: true,
                parent: 'app',
                url: '/patients/search?id:patientId',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_MANAGEMENT'],
                    pageTitle: 'sigmaCrmApp.patients.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/patients/patientView.html',
                        controller: 'PatientViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
